import { render, staticRenderFns } from "./info-form.vue?vue&type=template&id=42601490&scoped=true&"
import script from "./info-form.vue?vue&type=script&lang=js&"
export * from "./info-form.vue?vue&type=script&lang=js&"
import style0 from "./info-form.vue?vue&type=style&index=0&id=42601490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42601490",
  null
  
)

export default component.exports